import styled from 'astroturf/react'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'
import { BareButton } from '@calendly/ui/components/bare-button'
import { Typewriter } from 'react-simple-typewriter'
import slugify from 'slugify'

import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import { useTrack } from 'hooks/useTrack'

import LinkIcon from './illustration/link_icon.svg'
import PointerIcon from './illustration/pointer_icon.svg'
import CloudIcon from './illustration/square_cloud.svg'
import _Container from "illustration-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/illustration.js?styleId=Container";
import _Blue from "illustration-Blue.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/illustration.js?styleId=Blue";
import _Pill from "illustration-Pill.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/illustration.js?styleId=Pill";
import _Pointer from "illustration-Pointer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/illustration.js?styleId=Pointer";
import _Cloud from "illustration-Cloud.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/illustration.js?styleId=Cloud";
import _LinkImg from "illustration-LinkImg.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/illustration.js?styleId=LinkImg";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const Blue = /*#__PURE__*/styled('span', null, {
  displayName: "Blue",
  styles: _Blue
})

const Pill = /*#__PURE__*/styled('div', null, {
  displayName: "Pill",
  styles: _Pill
})

const Pointer = /*#__PURE__*/styled('img', null, {
  displayName: "Pointer",
  styles: _Pointer
})

const Cloud = /*#__PURE__*/styled('img', null, {
  displayName: "Cloud",
  styles: _Cloud
})

const LinkImg = /*#__PURE__*/styled('img', null, {
  displayName: "LinkImg",
  styles: _LinkImg
})

const AnimatedName = () => {
  const { firstName, lastName, fullName, inviteeEmailAsUsername } = useConfirmationPageData()

  const words = [firstName, lastName, fullName, inviteeEmailAsUsername, firstName]
    .map((word) => (typeof word === 'string' ? slugify(word.replace(/[*+~.()'"!:@]/g, '-'), { lower: true, strict: true }) : ''))
    .filter(Boolean)

  return (
    <Blue>
      <Typewriter words={words} />
    </Blue>
  )
}

export const Illustration = ({ animate }) => {
  const { firstName, currentUser, signUpByEmailPath, anonymousId, unbranded, isEmbedded } = useConfirmationPageData()
  const track = useTrack()

  if (isEmbedded || unbranded || currentUser) return null

  const onClick = () => {
    track({
      name: 'CTA Clicked',
      properties: {
        cta_text: 'personalized_url_image',
        cta_key: 'booking_page_confirmation',
      },
      dependencies: {
        user_uuid: currentUser?.user_uuid || anonymousId
      },
    })
    window.open(signUpByEmailPath, '_blank')
  }

  return (
    <BareButton onClick={onClick}>
      <Container>
        <Cloud src={CloudIcon} alt="Cloud" />
        <Pointer src={PointerIcon} alt="Pointer Icon" />
        <Pill>
          <LinkImg src={LinkIcon} alt="Link Icon" />
          <span>
            calendly.com/
            {animate ? <AnimatedName /> : firstName}
          </span>
        </Pill>
      </Container>
    </BareButton>
  )
}
